import {
  CONSTANTS_REQUEST,
  CONSTANTS_SUCCESS,
  CONSTANTS_FAILURE,
} from '../../common/actions-reducers/constants-actions';

import { appStore } from '../../index';


// Initial State
const initialState = {
  isFetching: false,
  indicators: {
    shis: {},
    crop_pathogens: {},
    allByKey: {},
    crop_thresholds: {},
    chemistry_parameters: {}
  },
};

const hiddenIndicatorKeys = [
  'Heterodera glycines',
  'Meloidogyne arenaria',
  'Meloidogyne floridensis',
  'Meloidogyne hapla',
  'Meloidogyne incognita',
  'Meloidogyne javanica',
  'Meloidogyne spp.'
]

// Listens for the general 'constants' endpoint action
// Reducer
export const indicatorReducer = (state = {...initialState}, action) => {
  switch(action.type) {
    case CONSTANTS_REQUEST:
      return {...state, isFetching: true};
    case CONSTANTS_SUCCESS:
      var newInds = {...action.constants}
      // ========================================
      // BAD HARD CODE REMOVE AS SOON AS POSSIBLE
      // Accounts from Salinas: because of soil type(?) lactucae thresholds are not accurate
      // TODO: product needs to come to a conclusion on soil type'
      var id = sessionStorage.userId
      if (id === '"69dad081-c8e3-48f5-8093-50dc4323cb2d"' || id ==='"6e463a8d-a09a-4742-9a1e-a2a4cc729f04"'){
        newInds.crop_thresholds['LETTUCE']['Fusarium oxysporum f. sp. lactucae']['percentile_75'] = 0.11046
      }
      // Hidden Pathogens: Nematode display is on hold as we determine how science accuracy
      // These values will still be generated, but we don't want to display or export
      for (let crop in newInds.crop_pathogens) {
        hiddenIndicatorKeys.forEach(ind=> delete newInds.crop_pathogens[crop].pathogens[ind])
      }
      // END HARD CODE
      // ========================================

      // ========================================
      // ANOTHER BAD HARD CODE - REMOVE TO RELEASE NEW SHI's
      // the production API needs to return the NEW SHI's for the pipeline, but the client
      // can't display them yet.
      let viewingUser = appStore.getState().auth.viewingUser
      if (!viewingUser || !viewingUser.admin){
        let toRemove = ["n_dnra", "n_denitrification", "p_mineralization", "p_solubilization", "nitrifiers", "oxygen"]
        toRemove.forEach(k => delete newInds.shis[k])
      }
      if (viewingUser && viewingUser.admin){
        let toRemove = ["aerobic_to_anaerobic_ratio", "n_availability", "p_availability"]
        toRemove.forEach(k => delete newInds.shis[k])
      }
      // END SECOND BAD HARD CODE
      // ========================================


      // flatten by key for easy reference in mapStateToProps
      let allByKey = { ...action.constants['shis'], ...action.constants['chemistry_parameters'] }
      Object.entries(action.constants['crop_pathogens']).map(([crop, crop_pathogens], i) => {
        !!crop_pathogens['pathogens'] && Object.entries(crop_pathogens['pathogens']).map(([pathKey, pathInfo], i) => {
          if (!(pathKey in allByKey)) {
            allByKey[pathKey] = pathInfo
          }
        })
      })
      newInds['allByKey'] = allByKey
      return {...state, isFetching: false, indicators: newInds};
    case CONSTANTS_FAILURE:
      return {...state, isFetching: false, errorMessage: action.error};
    default: {
      return state;
    }
  }
}

export const cropIndicatorThresholds = (indicatorsState, cropName, indKey) => {
  let low = null
  let high = null
  let inverted = null
  // non-inverted: above threshold_max is "good", below threshold_min is "bad"
  // inverted: below threshold_min is "good", above threshold_max is "bad"
  if (indicatorsState.indicators.crop_thresholds[cropName]) {
    if (indicatorsState.indicators.crop_thresholds[cropName][indKey]) {
      let twentyFifth = indicatorsState.indicators.crop_thresholds[cropName][indKey]['percentile_25']
      low = twentyFifth || 0
      // all cropIndicators will have a high threshold
      high = indicatorsState.indicators.crop_thresholds[cropName][indKey]['percentile_75']
      inverted = indicatorsState.indicators.crop_thresholds[cropName][indKey]['inverted']
    }
  }
  return { low, high, inverted }
}

export const cropPathogensSelectByCrop = (indicators, crop, by) => {
  if (!indicators.indicators.crop_pathogens[crop]){
    return by==='array' ? [] : {}
  }
  if (by === 'array'){
    return Object.values(indicators.indicators.crop_pathogens[crop].pathogens).sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
  } else {
    return indicators.indicators.crop_pathogens[crop].pathogens
  }
}
